import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { List, ListItem } from 'material-ui/List';
import { common } from './../../../../../../data/constants/index.js';
import { filterItemsByUserInput } from './../../helpers.js';
import FilterWrapper from './../FilterWrapper/FilterWrapper.jsx';
import { useLanguage } from './../../../../../../context/LanguageContext';

class ListFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items,
      selectedItems: this.props.selectedItems,
      stations: this.props.stations
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      selectedItems: nextProps.selectedItems,
      stations: nextProps.stations
    });
  }

  onChangeText = (event, value) => {
    const filteredItems = filterItemsByUserInput(value, this.props.items);
    this.setState({ items: filteredItems });
  };

  onCheck = event => {
    const valuesType = typeof this.props.items[0].value;
    let inputValue = event.target.value;

    // If values of items are Number, force the change
    // because Material UI always returns Strings
    if (valuesType === 'number') {
      inputValue = Number(inputValue);
    }

    const selectedItems = [...this.state.selectedItems];

    if (selectedItems.includes(inputValue)) {
      selectedItems.splice(selectedItems.indexOf(inputValue), 1);
      this.setState({ selectedItems });
    } else {
      this.setState({ selectedItems: [...selectedItems, inputValue] });
    }
  };

  onCloseFilter = () => {
    // Restore items to its original
    this.setState(
      {
        items: this.props.items
      },
      () => {
        this.props.updateLocalFilterPayload({
          [this.props.filterKey]: this.state.selectedItems
        });
      }
    );
  };

  renderItemsList = () => {
    if (this.state.items.length === 0)
      return (
        <div className='no-results list-item'>{this.props.FILTER_BAR?.LIST?.NO_RESULTS}</div>
      );

    if (Object.keys(this.state.stations).length > 0) {
      if (this.props.filterKey === 'stationCodes') {
        const stations = this.state.items;
        const stationCodes =
          this.state.stations &&
          this.state.stations.layover &&
          this.state.stations.layover.stationCodes;
        const filtered = stations.filter(
          item => stationCodes && stationCodes.indexOf(item.value) !== -1
        );
        return filtered.map(item => (
          <ListItem
            key={item.value}
            className='list-item'
            primaryText={`${item.name} - ${item.description}`}
            leftCheckbox={
              <Checkbox
                onCheck={this.onCheck}
                value={item.value}
                checked={this.state.selectedItems.includes(item.value)}
                className='checkbox'
                iconStyle={{ width: '18px', height: '18px', color: '#009688' }}
              />
            }
          />
        ));
      }
    }
    if (this.props.filterKey === 'activityAttributes') {
      const filtered = this.state.items.length > 1 ? this.state.items : [];
      return filtered.map(item => (
        <ListItem
          key={item.value}
          className='list-item'
          primaryText={`${item.name} - ${item.description}`}
          leftCheckbox={
            <Checkbox
              onCheck={this.onCheck}
              value={item.value}
              checked={this.state.selectedItems.includes(item.value)}
              className='checkbox'
              iconStyle={{ width: '18px', height: '18px', color: '#009688' }}
            />
          }
        />
      ));
    }
    return this.state.items.map(item => (
      <ListItem
        key={item.value}
        className='list-item'
        primaryText={`${item.name} - ${item.description}`}
        leftCheckbox={
          <Checkbox
            onCheck={this.onCheck}
            value={item.value}
            checked={this.state.selectedItems.includes(item.value)}
            className='checkbox'
            iconStyle={{ width: '18px', height: '18px', color: '#009688' }}
          />
        }
      />
    ));
  };

  render() {
    const filterWrapperProps = {
      changesInFilter: this.state.selectedItems.length,
      id: this.props.id,
      isUserAdded: this.props.isUserAdded,
      name: this.props.name,
      onCloseFilter: this.onCloseFilter,
      removeFilter: this.props.removeFilter
    };

    return (
      <FilterWrapper {...filterWrapperProps}>
        <TextField
          className='search-field'
          floatingLabelText={`${this.props.FILTER_BAR?.LIST?.LABEL || ''} ${this.props.name}`}
          style={{ fontSize: '12px' }}
          onChange={this.onChangeText}
        />
        <List className='options-list'>{this.renderItemsList()}</List>
      </FilterWrapper>
    );
  }
}

ListFilter.propTypes = {
  filterKey: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isUserAdded: PropTypes.bool,
  items: PropTypes.array,
  selectedItems: PropTypes.any,
  name: PropTypes.string.isRequired,
  removeFilter: PropTypes.func,
  updateLocalFilterPayload: PropTypes.func.isRequired,
  stations: PropTypes.object,
  FILTER_BAR: PropTypes.object
};

ListFilter.defaultProps = {
  isUserAdded: false,
  items: [],
  selectedItems: [],
  removeFilter: () => { },
  FILTER_BAR: {}
};

function ListFilterWrapper(props) {
  const { labels } = useLanguage();
  return <ListFilter {...props} FILTER_BAR={labels.FILTER_BAR} />;
}

export default ListFilterWrapper;
